import axios from 'axios'
import { getWorkProfileAPI } from '../api'

export const getWorkProfile = async (workerId, bookingId) => {
    try {
        const res = await axios.get(getWorkProfileAPI(workerId, bookingId))
        console.log(res)
        return res
    } catch (error) {
        return { success: false, error: error.message }
    }
}
